import request from "@/http/request"
// 获取安卓下载地址
export const getVersion = (params) => {
    return request.post('/api/market/version', params)
}